<template>
  <div id="address">
    <div class="addressCont">
      <el-row
        class="title"
        style="border-bottom:dashed 1px rgba(151,151,151,0.5);padding-bottom:8px;"
      >
        <!-- <el-col :span="24"><div class="grid-content bg-purple-dark ">地址管理 <span style="font-size: 14px!important;" class="col-999">（最多可创建5个收货地址）</span></div></el-col> -->
        <el-col :span="20" style="height:40px;line-height:40px;">
          <div class="grid-content bg-purple-dark box-title">
            <span
              style="height: 40px;font-size: 24px;font-family: MicrosoftYaHei;color: #262626;line-height: 40px;"
            >
              收货地址管理</span
            >
            <!-- <span style="font-size: 14px!important;" class="col-999">（最多可创建5个收货地址）</span> -->
          </div>
        </el-col>
        <el-col :span="4" style="height:40px;"
          ><button class="box-add" @click="adddz()">
            +新增收货地址
          </button></el-col
        >
      </el-row>
      <el-row style="margin-top:35px;" class="address_list">
        <el-col
          :span="24"
          v-for="item in siteList"
          :key="item.id"
          v-if="siteList != ''"
        >
          <div class="grid-content bg-purple">
            <div class="innerone" :class="item.default == 1 ? ' ' : ''">
              <div class="nameAndtel">
                <div style="line-height:20px;">
                  <span
                    style="display: inline-block;text-overflow: ellipsis;white-space: nowrap; margin-right:10px;height: 20px;font-size: 15px;font-family: MicrosoftYaHei;color: #262626;line-height: 20px;"
                    :title="item.name"
                    >{{ item.name }}</span
                  >
                  <span
                    class="defaultA "
                    @click="defaults(item.id)"
                    v-if="item.default == 0"
                    >设为默认</span
                  >
                  <span class="defaultB " v-if="item.default == 1"
                    >默认地址</span
                  >
                </div>
                <div style="line-height:20px;">
                  <span class="del" @click="removeSite(item.id, index)"
                    >删除</span
                  >
                  <span class="alter " @click="amendsits(item.id)">
                    修改
                  </span>
                </div>
              </div>
              <div class="sh">
                <p>
                  <span class="default"> 收货人：</span
                  ><span
                    style="display: inline-block;text-overflow: ellipsis;white-space: nowrap; margin-right:10px;height: 20px;font-size: 15px;font-family: MicrosoftYaHei;color: #262626;line-height: 20px;"
                    :title="item.name"
                    >{{ item.name }}</span
                  >
                </p>

                <p class="where">
                  <span class="default">收货地址：</span>
                  {{ item.province_str }}-{{ item.city_str }}-{{
                    item.county_str
                  }}
                  <span v-if="item.town_str != ''">-{{ item.town_str }}</span>
                  -{{ item.address }}
                </p>
                <p>
                  <span class="default">手机：</span
                  ><span
                    style="display: inline-block;max-width: 105px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                    >{{ item.phone }}</span
                  >
                </p>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="grid-content bg-purple" @click="adddz()">
            <div class="innerone addaddress" style="color: #323232;">
              <div class="p2">
                <span style="font-size:18px;font-weight:bold;">+</span
                >添加新地址
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <!--地址弹框-->
      <el-dialog :visible.sync="add" width="620px" center>
        <div slot="title">
          <!-- <div class="rect theme-bg"></div> -->
          <div
            class="dialog-title "
            style="height: 40px;font-size: 24px;font-family: MicrosoftYaHei;color: #262626;line-height: 40px;"
          >
            {{ poptype == 1 ? "添加收货地址" : "修改收货地址" }}
          </div>
        </div>
        <div class="demo-input-suffix">
          收&ensp;货&ensp;人：
          <el-input
            class="username"
            placeholder="请输入收货人"
            v-model="name"
          ></el-input>
        </div>
        <div class="demo-input-suffix">
          手机号码：
          <el-input
            class="telnum"
            placeholder="请输入手机号"
            v-model="tel"
          ></el-input>
        </div>
        <div class="linkage">
          所在地区：
          <el-select
            v-model="province"
            @change="choseProvince()"
            placeholder="--省--"
            id="province"
          >
            <!--这个change事件是select的，不是option的，别写在option里面-->
            <el-option
              v-for="item in province1"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            v-model="city"
            @change="choseCity"
            placeholder="--市--"
            id="city"
          >
            <el-option
              v-for="item in city1"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            v-model="county"
            @change="choseBlock"
            placeholder="--区--"
            id="town"
          >
            <el-option
              v-for="item in county1"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select
            v-if="this.four"
            v-model="town"
            @change="choseTown"
            placeholder="--乡镇--"
            id="county"
          >
            <el-option
              v-for="item in town1"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="demo-input-suffix" style="margin-bottom:22px;">
          详细地址：
          <el-input
            class="where1"
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="setess"
          ></el-input>
        </div>
        <!-- <el-checkbox v-model="checked">设为默认地址</el-checkbox> -->
        <div style="position:relative;">
          默认地址：
          <el-tooltip content="设为默认地址" placement="top">
            <el-switch
              width="54"
              v-model="checked"
              active-color="#E23130"
              inactive-color="#e5e5e5"
            >
            </el-switch>
          </el-tooltip>
        </div>
        <!-- {{checked}} -->
        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            v-if="poptype == 1"
            style="padding: 12px 40px;margin: 0 auto;display: inherit;"
            class="theme-bg tijia"
            @click="addSite()"
          >
            <span style="color:#fff">保 存</span>
          </el-button>
          <el-button
            type="primary"
            v-if="poptype == 2"
            style="padding: 12px 40px;margin: 0 auto;display: inherit;"
            class="theme-bg tijia"
            @click="sendDatas()"
          >
            <span style="color:#fff">保 存</span>
          </el-button>
        </div>
      </el-dialog>
      <!--地址弹框-->
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      province: "",
      provinceId: "",
      province1: [],
      city: "",
      cityId: "",
      city1: [],
      town: "",
      townId: "",
      town1: [],
      street: "",
      county: "",
      county1: [],
      four: true,
      addshow: false, //是否显示添加地址

      cprovince: "",
      ccity: "",
      ctown: "",
      ccounty: "",

      siteId: "", //修改地址的id
      poptype: "", //判断是修改还是添加
      add: false,
      setess: "",
      checked: false, //默认地址
      name: "",
      tel: "",
      popAddress: ["请选择", "请选择", "请选择", "请选择"],
      pop0: true, //遮罩显示否

      total: "",
      nums: "", //数量
      btnLoading: false, //提交按钮状态
      datas: [], //商品数据
      chosenAddressId: "", //收货地址ID
      content: "", //备注
      siteList: [] //收货地址数据
    };
  },
  methods: {
    //省
    adddz: function(e) {
      this.name = "";
      this.tel = "";
      this.setess = "";
      this.checked = true;
      this.poptype = 1;
      this.add = true;
      this.province1 = [];
      this.city1 = [];
      this.town1 = [];
      this.county1 = [];
      this.province = "";
      this.county = "";
      this.city = "";
      this.town = "";
      this.pop0 = false;
      var _this = this;

      this.$api.post(
        "address/address/getProvince",
        { id_example: this.$store.state.id_example, parent_id: 0 },
        res => {
          if (res.data.code == 100) {
            _this.province1 = res.data.data;
          }
        }
      );
    },
    // 市
    choseProvince: function() {
      this.city1 = [];
      this.town1 = [];
      this.county1 = [];
      this.city = "";
      this.county = "";
      this.town = "";
      this.pop0 = false;
      var _this = this;
      this.cprovince = this.province;

      // Jsonp('https://fts.jd.com/area/get?fid=' + this.province, null, (err, data) => {
      //        if (err) {
      //          return this.$toast('获取地址失败');
      //        }
      //        _this.city1=data;
      //      });

      this.$api.post(
        "address/address/getCity",
        { id_example: this.$store.state.id_example, area_id: this.province },
        res => {
          if (res.data.code == 100) {
            _this.city1 = res.data.data;
          }
        }
      );
    },
    // 区
    choseCity: function() {
      this.town1 = [];
      this.county1 = [];
      this.town = "";
      this.county = "";
      this.pop0 = false;
      var _this = this;
      this.ccity = this.city;

      // Jsonp('https://fts.jd.com/area/get?fid=' + this.city, null, (err, data) => {
      //        if (err) {
      //          return this.$toast('获取地址失败');
      //        }
      //        _this.county1=data;
      //      });

      this.$api.post(
        "address/address/getCounty",
        { id_example: this.$store.state.id_example, area_id: this.city },
        res => {
          if (res.data.code == 100) {
            _this.county1 = res.data.data;
          }
        }
      );
    },
    // 县
    choseBlock: function() {
      this.town1 = [];
      this.town = "";
      this.ctown = "";
      this.pop0 = false;
      var _this = this;
      this.ccounty = this.county;

      this.$api.get(
        "address/address/getTown",
        { id_example: this.$store.state.id_example, area_id: this.county },
        res => {
          if (res.data.code == 100) {
            if (res.data.data && res.data.data.length > 0) {
              this.four = true;
              this.town1 = res.data.data;
            } else {
              this.four = false;
            }
          }
        }
      );
    },
    //镇
    choseTown: function() {
      this.ctown = this.town;
    },
    //修改地址
    chaxuxiugai: function(p, c, co) {
      var _this = this;
      //省
      this.$api.post(
        "address/address/getProvince",
        { id_example: this.$store.state.id_example, parent_id: 0 },
        res => {
          if (res.data.code == 100) {
            _this.province1 = res.data.data;
          }
        }
      );
      //市
      this.$api.post(
        "address/address/getCity",
        { id_example: this.$store.state.id_example, area_id: this.province },
        res => {
          if (res.data.code == 100) {
            _this.city1 = res.data.data;
            // $.each(res.data.data, function(index, item) {
            //   var arr = { id: index, name: item };
            //   _this.city1.push(arr);
            // });
          }
        }
      );
      //区
      this.$api.post(
        "address/address/getCounty",
        { id_example: this.$store.state.id_example, area_id: this.city },
        res => {
          if (res.data.code == 100) {
            _this.county1 = res.data.data;
          }
        }
      );
      if (co != 0) {
        //县
        this.$api.get(
          "address/address/getTown",
          { id_example: this.$store.state.id_example, area_id: this.county },
          res => {
            if (res.data.code == 100) {
              if (res.data.data && res.data.data.length > 0) {
                this.town1 = res.data.data;
                this.four = true;
              } else {
                this.four = false;
                return;
              }
            }
          }
        );
      }

    },
    //添加地址
    addSite: function() {
      var reg = /^1\d{10}$/;
      var yb = /^[0-9]{6}$/;
      if (this.name == "") {
        this.$alert("请输入收货人", "提示", {
          confirmButtonText: "确定",
          callback: action => {}
        });
        return false;
      }
      if (this.tel == "") {
        this.$alert("手机号码不能为空", "提示", {
          confirmButtonText: "确定",
          callback: action => {}
        });
        return false;
      }
      if (!reg.test(this.tel)) {
        this.$alert("请输入正确的手机号", "提示", {
          confirmButtonText: "确定",
          callback: action => {}
        });
        return false;
      }
      if (this.province == "" || this.city == "" || this.county == "") {
        this.$alert("请输入完整地址", "提示", {
          confirmButtonText: "确定",
          callback: action => {}
        });
        return false;
      }
      if (this.town1 != "" && this.town == "") {
        this.$alert("请输入完整地址", "提示", {
          confirmButtonText: "确定",
          callback: action => {}
        });
        return false;
      }
      this.$api.post(
        "user/address/add",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          name: this.name,
          phone: this.tel,
          province: this.province,
          city: this.city,
          county: this.county,
          town: this.town,
          default: this.checked == true ? 1 : 0,
          province_str: $("#province").val(),
          city_str: $("#city").val(),
          county_str: $("#town").val(),
          town_str: $("#county").val() == undefined ? "" : $("#county").val(),
          address: this.setess
        },
        res => {
          if (res.data.code == 100) {
            this.four = true
            this.add = false;
            this.getaddresslist();
            this.$alert("添加成功", "提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          } else {
            this.$alert(res.data.message, "提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        }
      );
    },
    //删除地址
    removeSite: function(id, index) {
      this.$msgbox({
        title: "消息",
        message: "确定要删除此收货地址吗?",
        showCancelButton: true,
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            setTimeout(() => {
              this.$api.post(
                "user/address/delete",
                {
                  id_example: this.$store.state.id_example,
                  token_user: this.$store.state.user_id,
                  id_address: id
                },
                res => {
                  done();
                  if (res.data.code == 100) {
                    this.getaddresslist();
                  }
                }
              );
            }, 100);
          } else {
            done();
          }
        }
      });
    },
    //修改地址
    amendsits: function(id) {
      this.siteId = id;
      this.poptype = 2;
      this.$api.post(
        "user/address/userinfo",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          address_id: id
        },
        res => {
          if (res.data.code == 100) {
            this.add = true;
            this.name = res.data.data.name;
            this.tel = res.data.data.phone;
            this.setess = res.data.data.address;
            this.province = res.data.data.province_str;
            this.cprovince = res.data.data.province;
            this.city = res.data.data.city_str;
            this.ccity = res.data.data.city;
            this.county = res.data.data.county_str;
            this.ccounty = res.data.data.county;
            if (res.data.data.town_str != "") {
              this.town = res.data.data.town_str;
              this.ctown = res.data.data.town;
              this.four = true;
            } else {
              this.four = false;
            }
            res.data.data.default == 1
              ? (this.checked = true)
              : (this.checked = false);
            this.chaxuxiugai(
              res.data.data.province,
              res.data.data.city,
              res.data.data.town
            );
          }
        }
      );
    },
    //保存修改地址
    sendDatas: function() {
      if (this.town1 != "" && this.ctown == "") {
        this.$alert("请输入完整的地址", "提示", {
          confirmButtonText: "确定",
          callback: action => {}
        });
        return false;
      }
      this.$api.post(
        "user/address/update",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          id_address: this.siteId,
          name: this.name,
          phone: this.tel,
          province: this.cprovince,
          city: this.ccity,
          county: this.ccounty,
          town: this.ctown,
          default: this.checked == true ? 1 : 0,
          province_str: $("#province").val(),
          city_str: $("#city").val(),
          county_str: $("#town").val(),
          town_str: $("#county").val() == undefined ? "" : $("#county").val(),
          address: this.setess
        },
        res => {
          if (res.data.code == 100) {
            this.four = true
            setTimeout(() => {
              this.add = false;
              this.getaddresslist();
            });
          } else {
            this.$alert("请输入完整的地址", "提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        }
      );
    },
    //地址列表查询
    getaddresslist: function() {
      this.$api.post(
        "user/address/list",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id
        },
        res => {
          if (res.data.code == 100) {
            var _this = this;
            this.siteList = [];
            $.each(res.data.data, function(index, item) {
              _this.siteList.push(item);
            });
          }
        }
      );
    },
    //默认地址
    defaults(id) {
      this.$api.post(
        "user/address/setdefault",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          id_address: id
        },
        res => {
          if (res.data.code == 100) {
            this.getaddresslist();
          }
        }
      );
    }
  },
  created() {
    this.getaddresslist();
  }
};
</script>

<style lang="less">
.el-switch__core:after {
  width: 26px;
  height: 26px;
  top: -1px;
  left: -1px;
  border: 1px solid #dbdbdb;
  box-shadow: 4px 0px 4px 0px rgba(159, 159, 159, 0.3);
}
.el-switch__core {
  height: 26px;
  line-height: 26px;
  border-radius: 13px;
  border-radius: 13px;
  boxsizing: border-box;
}
.el-switch.is-checked .el-switch__core:after {
  box-shadow: -4px 0px 4px 0px #c92524;

  border: 1px solid #e23130;
}
.tijia {
  width: 168px;
  height: 40px;
  background: #e23130;
  border-radius: 6px !important;
  border: 1px solid #e23130;
  font-size: 16px;
}
.sh {
  p {
    height: 17px;
    font-size: 13px;
    font-family: MicrosoftYaHei;
    color: #272727;
    line-height: 17px;
    margin-top: 15px;
    .default {
      display: inline-block;
      width: 66px;
      text-align: right;
      margin-right: 20px;
      height: 17px;
      font-size: 13px;
      font-family: MicrosoftYaHei;
      color: #7a7a7a;
      line-height: 17px;
    }
  }
}
#address {
  padding: 10px 30px;
  width: 985px;
  box-sizing: border-box;
  min-height: 572px;
}
.box-add {
  display: flex;
  align-items: center;
  width: 130px;
  height: 30px;
  margin-top: 6px;
  box-sizing: border-box;
  background: rgba(219, 219, 219, 0.2) !important;
  border-radius: 6px !important;
  border: 1px solid #dbdbdb !important;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #535353;
  justify-content: center;
  transition: all 0.5s;
  &:hover {
    background: #fff !important;
  }
}
.box-add {
}

.box-title {
  height: 40px;
  font-size: 24px;
  font-family: MicrosoftYaHei;
  color: #262626;
  line-height: 40px;
}
#address {
  width: 975px;
  float: left;
  /*height: 465px;*/
  background: #fff;
}

#address .title {
  height: 55px;
  line-height: 55px;
  font-size: 16px;
}
#address .title .grid-content {
  padding: 0 20px;
  font-size: 16px;
}
#address .address_list {
}
#address .innerone {
  border: 1px solid #ddd;
  padding: 20px 25px;
  position: relative;
  margin-bottom: 20px;
  transition: all 0.5s;
}
// #address .innerone:hover {
//   border-width: 3px;
//   padding: 20px;
//   border-image: url('/static/img/address_border.png') 3 stretch;
//   .defaultA,
//   .defaultB {
//     top: 20px;
//     right: 18px;
//   }
//   .alter {
//     bottom: 16px;
//     right: 18px;
//   }
//   .del {
//     bottom: 16px;
//     right: 62px;
//   }
//   .defaultAdd {
//     bottom: -4px;
//     right: 0px;
//   }
// }
#address .del {
  font-size: 13px;
  font-family: MicrosoftYaHei;
  color: #175fa0;
  line-height: 17px;
  margin-right: 20px;
}
#address .innerone .defaultAdd {
  position: absolute;
  bottom: -2px;
  right: 2px;
  width: 25px;
  font-size: 28px;
}
#address .innerone.active {
  border: 1px solid red;
}
#address .innerone .defaultA {
  width: 68px;
  height: 23px;
  display: inline-block;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #b9b9b9;
  line-height: 23px;
  text-align: center;
  font-family: MicrosoftYaHei;
  color: #262626;
  font-size: 12px;
}
#address .innerone .defaultB {
  width: 68px;
  height: 23px;
  display: inline-block;
  background: #e23130;
  border-radius: 4px;
  line-height: 23px;
  text-align: center;
  color: #fff;
  font-size: 12px;
  cursor: default;
}
#address .innerone .alter {
  font-size: 13px;
  font-family: MicrosoftYaHei;
  color: #175fa0;
  line-height: 17px;
}

#address .nameAndtel {
  border-bottom: 1px dashed #ddd;
  margin-bottom: 10px;
  padding-bottom: 15px;
  display: flex;
  justify-content: space-between;
}

#address .p1 {
  font-size: 60px;
  text-align: center;
}
#address .p2 {
  text-align: center;
  height: 19px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #1e64a2;
  line-height: 19px;
}
#address .addaddress {
  border: 1px dashed #ddd;
  cursor: pointer;
}
/*地址弹框*/
.amendinfo {
  left: 75px;
  position: relative;
  top: -60px;
}
.amendinfo span {
  display: inline-block;
  width: 80px;
  height: 38px;
  background: #fff;
  position: absolute;
  top: 1px;
  line-height: 38px;
  font-size: 14px;
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.pop1 {
  left: 15px;
}
.pop2 {
  left: 154px;
}
.pop3 {
  left: 294px;
}
.pop4 {
  left: 430px;
}
#address .el-dialog__title {
  font-size: 16px;
}
#address .el-dialog__close {
  position: relative;
  top: -5px;
}
#address .el-dialog {
  width: 680px;
  // height: 500px;
  // box-shadow: 2px 2px 5px #555;
  /* border: 5px solid #ccc; */
  border-radius: 6px;
  overflow: hidden;
}
#address .el-dialog__header {
  padding: 10px 20px 10px;
  background: #f5f5f5;
}
#address .username.el-input,
.telnum.el-input {
  width: 285px;
  height: 40px;
  margin-left: 4px;
}
#address .demo-input-suffix {
  margin-bottom: 20px;
  /* height: 36px; */
}
#address .linkage .el-input__inner {
  width: 99px;
  font-size: 12px;
}
#address .el-select {
  margin-right: 5px;
  margin-bottom: 20px;
}
#address .where1 {
  width: 400px;
  margin-left: 4px;
  vertical-align: middle;
}
#address .el-checkbox {
  margin-left: 74px;
  /* margin-top: 20px; */
}
/*.el-select-dropdown.el-popper{*/
/*top:315px;*/
/*}*/
#address .el-dialog__body {
  padding: 20px 20px 0 50px;
}
#address .dialog-footer {
  margin-top: 30px;
  margin-bottom: 40px;
}
// #address .dialog-footer button {
//   width: 125px;
//   height: 42px;
// }
#address .el-dialog__header {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
}
#address .rect {
  width: 25px;
  height: 6px;
  border-radius: 3px;
  margin: 0px auto 0px auto;
}
.dialog-title {
  color: #0f2134;
  // margin-top: 8px;
  font-size: 16px;
  letter-spacing: 2px;
  font-weight: 500;
}
.v-modal {
  background: rgba(38, 38, 38, 0.8);
  opacity: 1;
}
/deep/ .el-switch.is-checked .el-switch__core:after {
  margin-left: -26px;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/cont/address.vue